// Pricing de los cuatro planes de agencia, decidido por fede el 2026-10-05
// (fuente: dashbo-sacudon/estrategia/propuesta-pricing-2026-10.md).
//
// Los cuatro planes traen TODAS las funciones, incluido el conector de Looker Studio: ya no hay
// selector «con / sin Looker» ni Looker se cobra aparte. Los planes se distinguen por cantidades.
//
// Espejos que se mantienen A MANO (nada los concilia, salvo el test de cada lado):
// - Backend: `subscription/checkout_views.py` (PLAN_PRICES_USD / PLAN_PRICES_ARS), que es el que cobra.
// - Web: `Dashbo - Web/includes/pricing.php`.
// ARS = USD × 1.640, más IVA, sin ajuste por IPC (precios de octubre de 2026). Cada período es el
// precio mensual con el descuento de PERIODS, redondeado igual que en el backend.

export const PERIODS = {
    yearly: { discount: 30 },
    semestral: { discount: 20 },
    trimestral: { discount: 10 },
    monthly: { discount: 0 },
};

export const PLANS = [
    {
        id: 'profesional',
        nameKey: 'upgrade_to_dashbo.plans.profesional.name',
        descriptionKey: 'upgrade_to_dashbo.plans.profesional.description',
        prices: {
            usd: { monthly: 60, trimestral: 54, semestral: 48, yearly: 42 },
            ars: { monthly: 98400, trimestral: 88560, semestral: 78720, yearly: 68880 },
        },
        // `teamUsers: null` = ilimitados. `approxClients` es orientativo: con Meta y Google por cliente.
        quantities: { linkedAccounts: 30, approxClients: 15, teamUsers: 3, portalAccesses: 10 },
        // Onboarding 1:1 en vivo y soporte prioritario.
        premiumSupport: false,
    },
    {
        id: 'agency',
        nameKey: 'upgrade_to_dashbo.plans.agency.name',
        descriptionKey: 'upgrade_to_dashbo.plans.agency.description',
        prices: {
            usd: { monthly: 120, trimestral: 108, semestral: 96, yearly: 84 },
            ars: { monthly: 196800, trimestral: 177120, semestral: 157440, yearly: 137760 },
        },
        quantities: { linkedAccounts: 70, approxClients: 35, teamUsers: 8, portalAccesses: 25 },
        premiumSupport: false,
    },
    {
        id: 'big_agency',
        nameKey: 'upgrade_to_dashbo.plans.big_agency.name',
        descriptionKey: 'upgrade_to_dashbo.plans.big_agency.description',
        highlighted: true,
        prices: {
            usd: { monthly: 240, trimestral: 216, semestral: 192, yearly: 168 },
            ars: { monthly: 393600, trimestral: 354240, semestral: 314880, yearly: 275520 },
        },
        quantities: { linkedAccounts: 150, approxClients: 75, teamUsers: 15, portalAccesses: 50 },
        premiumSupport: true,
    },
    {
        id: 'epic_agency',
        nameKey: 'upgrade_to_dashbo.plans.epic_agency.name',
        descriptionKey: 'upgrade_to_dashbo.plans.epic_agency.description',
        prices: {
            usd: { monthly: 420, trimestral: 378, semestral: 336, yearly: 294 },
            ars: { monthly: 688800, trimestral: 619920, semestral: 551040, yearly: 482160 },
        },
        quantities: { linkedAccounts: 300, approxClients: 150, teamUsers: null, portalAccesses: 100 },
        premiumSupport: true,
    },
];

export function formatPrice(price, currency) {
    return price.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function getPrice(plan, currency, period) {
    return plan.prices[currency.toLowerCase()][period];
}
